import { render, staticRenderFns } from "./TableMusicBgm.vue?vue&type=template&id=58e8b4f8&scoped=true&"
import script from "./TableMusicBgm.vue?vue&type=script&lang=js&"
export * from "./TableMusicBgm.vue?vue&type=script&lang=js&"
import style0 from "./TableMusicBgm.vue?vue&type=style&index=0&id=58e8b4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e8b4f8",
  null
  
)

export default component.exports